var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "span",
      [
        _c("div", { staticClass: "text-tips" }, [
          _vm._v(_vm._s(_vm.remindMessage))
        ]),
        _vm._v(" "),
        _vm.fileObj.fileModelUrl
          ? _c(
              "a",
              {
                staticStyle: { color: "#16ade9", "margin-right": "20px" },
                attrs: { href: _vm.fileObj.fileModelUrl, target: "_blank" }
              },
              [
                _c("img", {
                  staticStyle: { position: "relative" },
                  attrs: { src: require("@/assets/images/common/serch.png") }
                }),
                _vm._v("\n      查看示例\n    ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.fileObj.sourceFileUrl && _vm.fileObj.sourceFileUrl != "[]"
          ? _vm._l(_vm.$util.convertImage(this.fileObj.sourceFileUrl), function(
              url
            ) {
              return _c(
                "a",
                {
                  key: url,
                  staticStyle: { color: "#16ade9", "margin-right": "20px" },
                  attrs: { href: "javascript:void(0);", target: "_self" },
                  on: {
                    click: function($event) {
                      return _vm.downLoad(url)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { position: "relative" },
                    attrs: { src: require("@/assets/images/common/kan.png") }
                  }),
                  _vm._v("\n        模板文件\n      ")
                ]
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showAuthorizeFile
          ? _c(
              "a",
              {
                staticStyle: { color: "#ed3e3e" },
                attrs: { href: "javascript:void(0);" },
                on: { click: _vm.downLoadAuthor }
              },
              [
                _c("img", {
                  staticStyle: { position: "relative", top: "4px" },
                  attrs: {
                    src: require("@/assets/images/common/downloadImg.svg")
                  }
                }),
                _vm._v("\n      下载授权书\n    ")
              ]
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c79f6f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c79f6f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/SampleFile/index.vue
// module id = null
// module chunks = 